module.exports = __webpack_public_path__ + "static/img/2.0973e73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/1/2.png
// module id = /grf
// module chunks = 0